import React, { useEffect, useState, useMemo } from 'react';

import i18next from '@frolight/i18n';

import useFormattedLocalizedText from '@frolight/hooks/useLocalizedFormattedText';
import useLocalizationUtils from '@frolight/hooks/useLocalizationUtils';
import useAuthenticatedAPIServiceCall from '@frolight/hooks/useAuthenticatedAPIServiceCall';
import useUserPreferences from '@frolight/hooks/useUserPreferences';
import useLocaleUpdater from '@frolight/hooks/useLocaleUpdater';

import { patchPreferences } from '@frolight/services/api/userService';

const LocaleSelector = ({ theme = 'light' }) => {
  const { lftext } = useFormattedLocalizedText();

  const [selectedLanguage, setSelectedLanguage] = useState(i18next.language);

  const { setSelectedLocale, setHasChanged } = useLocaleUpdater();
  const { userPreferences } = useUserPreferences();
  const authenticatedAPIServiceCall = useAuthenticatedAPIServiceCall();
  const { changeLocale } = useLocalizationUtils();

  // Compute language names once and store them
  const languagesWithNames = useMemo(() => {
    return i18next.languages.map(l => ({
      code: l,
      name: lftext(`locale.${l}`) || l // Fallback to language code if translation is missing
    }));
  }, [i18next.languages, lftext]);

  useEffect(() => {
    setSelectedLanguage(i18next.language);
  }, [ i18next.language ]);

  const updateUserPreferences = (languageCode) => {
    if (userPreferences?.locale && userPreferences.locale !== languageCode) {
      authenticatedAPIServiceCall(patchPreferences, {
        abortController: new AbortController(),
        opts: {
          locale: languageCode,
        },
      });
    }
  }

  const selectLanguage = (languageCode) => {
    updateUserPreferences(languageCode);
    changeLocale(languageCode);
    setSelectedLocale(languageCode);
    setHasChanged(true);
  };

  return (
    <form className={`locale_selector  locale_selector--${theme}`}>
      <label className={`locale_selector__label locale_selector__label--${theme}`} htmlFor='locale-selector-unique_id'>{lftext('components.locale_selector.text_to_speach_label')}</label>
      <select className={`locale_selector__selector`} id='locale-selector-unique_id' value={selectedLanguage} onChange={(e) => selectLanguage(e.target.value)}>
        {languagesWithNames.map(({ code, name }) => (
          <option className="locale_selector__menu-item" key={`lang-${code}`} value={code}>{name}</option>
        ))}
      </select>
    </form>
  );
};

export default LocaleSelector;
